import axios from "../../../axios"

export default {
  subscriberSegments(subscriberId) {
    return axios.post('', {
      query: `
        query {
          subscriberSegments (subscriber_id: ${subscriberId}) {
            categories {
              id,
              name
            }
          }
        }
      `
    })
  },
}
